import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { MetricWidgetBase } from '@components/overview-dashboard/common/mixins';

export const ExperienceDashboardWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const OverviewWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  place-content: baseline space-evenly;
`;

export const MetricWidget = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MetricTitle = styled.div`
  font-style: normal;
  font-weight: 400;
  color: rgb(0 0 0 / 85%);
  font-size: 16px;

  ${breakpoint('desktop')`
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    `};
`;

export const MetricDivider = styled.div`
  height: 1px;
  background: #979797;
  opacity: 0.5;
  padding-bottom: 1px;
`;

export const MetricsNumbersContainer = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
`;

export const MetricsDescText = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  text-align: left;
`;

export const MetricWidgetWrapper = styled.div`
  ${MetricWidgetBase};

  ${breakpoint('tablet')`
        width: 100%;
    `};

  ${breakpoint('desktop')`
        width: 32%;
        height: 400px;
    `};

  ${breakpoint('mobile')`
        width: 100%;
    `};
`;

export const MetricContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 10px;
  flex-grow: 1;
`;

export const MetricChart = styled.div`
  /* Chart container */
`;

export const Layer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 10;
  background-color: rgb(255 255 255);
  overflow: hidden;
`;
